export default __webpack_public_path__ + "static/media/marn.c8261012.svg";